import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as state from '../../../../../../../../state'
import * as modals from '../../../modals'

/**
 * Shared responsible persons component.
 * Works for both record and cluster contexts.
 */
@ngCore.Component({
  imports: [
    ds.overlay.confirmation.Component,
    ds.table.Component,
    modals.responsiblePersons.Component,
    modals.shared.createEmployeeForm.Component,
  ],
  selector: 'atn-space-responsible-persons',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** When true, the component is in read-only mode (e.g. record assigned to a cluster). */
  public readonly isReadonlySg = ngCore.input(false, { alias: 'readonly' })

  /** Responsible persons collection */
  public readonly collectionSg = ngCore.input.required<
    | state.space.full.recordResponsiblePersons.Collection
    | state.space.full.clusterResponsiblePersons.Collection
  >({ alias: 'collection' })

  /** Canonical table input for the active responsible-person collection. */
  public readonly tableConfigSg = ngCore.computed(
    (collection = this.collectionSg(), isReadonly = this.isReadonlySg()) =>
      ({
        collection,
        view: {
          creation: isReadonly ? false : this.addPersonClickHandler,
          showColumnSettings: false,
          title: 'Responsible Persons',
        },
      }) satisfies ds.table.ec.Config.Input.ForTable,
  )

  /** @see {@link state.space.full.employee.Collection} */
  public readonly employeeEc = ngCore.inject(
    state.space.full.employee.Collection,
  )

  /** @see {@link ds.color.Legacy.PredefinedStyle} */
  public readonly confirmationOverlayStyle = ds.color.Legacy.PredefinedStyle

  /** Handle add responsible person — opens the employee selection modal */
  public addPersonClickHandler = () => {
    this.collectionSg()
      .plugins.editingPlugin.feature.actions.edit.from(
        'ResponsiblePersons.Add.Clicked',
      )
      .dispatch({
        id: ec.plugins.standard.editing.models.CreationId.generate(),
      })
  }

  /** Confirms the deletion of the responsible person marked for removal */
  public confirmDeletionClickHandler(): void {
    this.collectionSg()
      .plugins.editingPlugin.feature.actions.submit.from(
        'ResponsiblePersons.Delete.Confirmation.Footer.Buttons.Confirm.Clicked',
      )
      .dispatch({ delete: true })
  }

  /** Cancels the deletion of the responsible person marked for removal */
  public cancelDeletionClickHandler(): void {
    this.collectionSg()
      .plugins.editingPlugin.feature.actions.discard.from(
        'ResponsiblePersons.Delete.Confirmation.Footer.Buttons.Cancel.Clicked',
      )
      .dispatch({ delete: true })
  }

  /** Confirms the update of the responsible person marked for update */
  public updateResponsiblePersonHandler(): void {
    this.collectionSg()
      .plugins.editingPlugin.feature.actions.submit.from(
        'ResponsiblePersons.Update.Confirmation.Footer.Buttons.Confirm.Clicked',
      )
      .dispatch({ update: true })
  }

  /** Cancels the update of the responsible person marked for update */
  public cancelResponsiblePersonUpdateHandler(): void {
    this.collectionSg()
      .plugins.editingPlugin.feature.actions.discard.from(
        'ResponsiblePersons.Update.Confirmation.Footer.Buttons.Cancel.Clicked',
      )
      .dispatch({ update: true })
  }
}
